import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/respimg/ls.respimg';

import lazySizes from 'lazysizes';

lazySizes.cfg.lazyClass = 'js-a-img--lazyload';
lazySizes.cfg.loadingClass = 'state-a-img__image--loading';
lazySizes.cfg.preloadClass = 'state-a-img__image--preload';
lazySizes.cfg.loadedClass = 'state-a-img__image--loaded';
lazySizes.cfg.loadMode = 1;
